import React, { useState, useEffect, FC } from "react";
import Content from "../../../layout/content/Content";
import Head from "../../../layout/head/Head";
import { Alert, Card, ModalHeader } from "reactstrap";
import {
  Button,
  Block,
  BlockBetween,
  BlockDes,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  Icon,
  Row,
} from "../../../components/Component";
import { Col } from "reactstrap";
import { Link, useParams } from "react-router-dom";
import Swal from "sweetalert2";
import sites from "../../../api/master/sites";
import { Modal, ModalBody, Spinner } from "reactstrap";
import FormInput from "../../form-components/InputComponent";
import FormDatePicker from "../../form-components/DatePicker";
import FormSelect from "../../form-components/SelectComponent";
import { FormProvider, useForm } from "react-hook-form";
import FormCheckbox from "../../form-components/CheckboxComponent";
import rolesApi from "../../../api/master/roles";
import usersApis from "../../../api/master/users";
import FormatDate from "../DateFormater";
import moment from "moment";
import FormMultiSelect from "../../form-components/MultiSelectComponent";
import dayjs from "dayjs";
import { Table, Spin, Flex } from "antd";
import { useSelector } from "react-redux";
import UserAccessibilityModal from "./UserAccessibilityModal";

interface SelectOptions {
  label: string;
  value: string;
}
const UserViewDetails: FC = () => {
  const { data: accessibility } = useSelector(
    (state: any) => state.accessibility
  );
  const [allowedActions, setAllowedActions] = useState<any>({
    add: 0,
    view: 0,
    edit: 0,
    approve: 0,
    reject: 0,
    cancel: 0,
  });

  useEffect(() => {
    if (accessibility) {
      try {
        const { add, view, edit, approve, reject, cancel } =
          accessibility["Master"];
        setAllowedActions({ add, view, edit, approve, reject, cancel });
      } catch (error) {
        console.log(error);
      }
    }
  }, [accessibility]);
  const [sm, updateSm] = useState(false);
  const [mobileView, setMobileView] = useState(false);
  let { userId } = useParams();
  const [data, setData] = useState<any>();
  const [modalGI, setGIModal] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [countries, setCountries] = useState<SelectOptions[]>([]);
  const [states, setStates] = useState<SelectOptions[]>([]);
  const [districtOptions, setDistrictOptions] = useState<SelectOptions[]>([]);
  const [formData, setFormData]: any = useState({
    name: "",
    workingSite: "",
    email: "",
    phoneNumber: "",
    DOB: "",
    DOJ: "",
    bloodGroup: "",
    area: "",
    city: "",
    district: "",
    state: "",
    country: "",
    userOrganisation: "",
    department: "",
    role: "",
    reportingManagerRole: "",
    reportingManager: "",
    PIN: "",
    accessibility: [],
  });
  const methods = useForm({
    mode: "onChange",
  });

  const { handleSubmit, watch, setValue, getValues } = methods;
  const [accessebilityKeys, setaccessebilityKeys] = useState([]);
  const updatedAccessibilityOptions = [
    {
      label: "Sub Feature",
      value: "Sub Feature",
    },
    {
      label: "Create / Add",
      value: "ADD",
    },
    {
      label: "View",
      value: "VIEW",
    },
    {
      label: "Edit / Update",
      value: "EDIT",
    },
    {
      label: " Delete / Inactive",
      value: "CANCEL",
    },
    {
      label: "Approve / Reject",
      value: "APPROVE",
    },
  ];
  const updatedReportsAccessibilityOptions = [
    {
      label: "Create / Add",
      value: "ADD",
    },
    {
      label: "View",
      value: "VIEW",
    },
    {
      label: "Edit / Update",
      value: "EDIT",
    },
    {
      label: " Delete / Inactive",
      value: "CANCEL",
    },
    {
      label: "Approve / Reject",
      value: "APPROVE",
    },
  ];

  const [originalData, setOriginalData] = useState<any>();

  const [roleData, setRoleData] = useState<SelectOptions[]>([]);
  const [departmentData, setDepartmentData] = useState<SelectOptions[]>([]);
  const [organisationData, setOrganisationData] = useState<SelectOptions[]>([]);
  const [workingSites, setWorkingSites] = useState<any>([]);
  const [modalEditBlockName, setModalEditBlockName]: any = useState("");
  const [showreporting, setShowreporting] = useState(false);
  const [allRolesData, setAllRolesData] = useState<any[]>([]);
  const [reportingManagerDropDownData, setReportingManagerDropDownData] =
    useState<SelectOptions[]>([]);
  const [reportingMessage, setReportingMessage] = useState(false);
  const [alertInfo, setAlertInfo] = useState({
    type: "", // 'success' or 'error'
    message: "",
    errors: [],
  });
  const getCountries = async () => {
    try {
      const _countries = await usersApis.getCountrys();
      console.log(_countries);
      if (_countries.status) {
        if (_countries.data.length > 0) {
          const transformedData = _countries.data.map((item: any) => ({
            value: item.countryId.toString(),
            label: item.countryName,
          }));
          setCountries(transformedData);
          if (selectedCountry) {
            setValue("country", selectedCountry.value);
          }
        }
      }
    } catch (error: any) {
      console.log(error.message);
    }
  };
  const fetchStatesByCountry = async (countryId: string, stateId?: string) => {
    try {
      const data = await usersApis.getStatesByCountry(countryId);
      const stateOptions = data?.data?.map((state: any) => ({
        value: state.stateId,
        label: state.stateName,
      }));
      if (stateOptions.length > 0) setStates(stateOptions);
      if (stateId) {
        const state = stateOptions.find(
          (state: SelectOptions) => state.value === stateId
        );
        if (!state) {
          return;
        }
        setValue("state", state.value);
      }
    } catch (error) { }
  };

  const getDistricts = async (stateID: any, districtsID?: any) => {
    try {
      const districts = await usersApis.getDistrictsByState(stateID);
      console.log(districts);
      if (districts.status) {
        if (districts.data.length > 0) {
          const transformedData = districts.data.map((item: any) => ({
            value: item.districtId.toString(),
            label: item.districtName,
          }));
          setDistrictOptions(transformedData);
          if (districtsID) {
            setValue("district", districtsID);
          } else {
            setValue("district", districts.data[0].districtId.toString());
          }
        }
      }
    } catch (error: any) {
      console.log(error.message);
    }
  };
  const fetchWorkingSites = async () => {
    try {
      const { data, status, message } = await sites.fetchSites();
      if (status) {
        setWorkingSites(
          data.map((item: any) => ({
            label: item.name,
            value: item.siteID?.toString(),
          }))
        );
      } else {
        Swal.fire("Error", message, "error");
      }
    } catch (err: any) {
      Swal.fire("Error", err.message, "error");
    }
  };
  const onStateChange = (e: any) => {
    getDistricts(e);
  };

  const selectedCountry = watch("country");

  const onSubmit = async (data_: any) => {
    setIsSubmitting(true);
    console.log("data", data_);
    const prefix = `${modalEditBlockName}_`;

    // Step 1: Build permissionsMap
    const permissionsMap: Record<string, Record<string, number>> = {};

    Object.entries(data_).forEach(([key, value]) => {
      if (!key.startsWith(prefix)) return;

      const [, moduleID, action] = key.split("_");
      if (!permissionsMap[moduleID]) {
        permissionsMap[moduleID] = {};
      }

      permissionsMap[moduleID][action] = value ? 1 : 0;
    });

    console.log("permissionsMap", permissionsMap);

    // Step 2: Set updated data
    const updatedAccessibility = data.accessibility.map((entry: any) => {
      console.log(
        "entry.category !== modalEditBlockName",
        entry.category,
        modalEditBlockName,
        entry.category !== modalEditBlockName
      );
      if (entry.category !== modalEditBlockName) return entry;
      console.log("entry", entry);

      if (modalEditBlockName === "Reports") {
        // For Reports, modules are nested
        const updatedModules = entry.modules.map((subCat: any) => ({
          ...subCat,
          modules: subCat.modules.map((mod: any) => {
            const actions = permissionsMap[mod.moduleID];
            if (!actions) return mod;
            return {
              ...mod,
              actions: {
                add: actions.add,
                view: actions.view,
                edit: actions.edit,
                cancel: actions.cancel,
                approve: actions.approve,
                reject: actions.reject,
              },
              allowedToEdit: mod.allowedToEdit,
            };
          }),
        }));
        return { ...entry, modules: updatedModules };
      } else if (
        modalEditBlockName === "Masters" ||
        modalEditBlockName === "Dashboard"
      ) {
        const updatedModules = entry.modules.map((mod: any) => {
          const actions = permissionsMap[mod.moduleID];
          if (!actions) return mod;

          const isAddChecked = actions.add === 1;

          return {
            ...mod,
            actions: {
              add: isAddChecked ? 1 : 0,
              view: isAddChecked ? 1 : 0,
              edit: isAddChecked ? 1 : 0,
              cancel: isAddChecked ? 1 : 0,
              approve: isAddChecked ? 1 : 0,
              reject: isAddChecked ? 1 : 0,
            },
            allowedToEdit: mod.allowedToEdit,
          };
        });
        console.log("updatedModules", updatedModules);
        return {
          ...entry,
          modules: updatedModules,
        };
      } else {
        const updatedModules = entry.modules.map((mod: any) => {
          const modIdStr = mod.moduleID; // ensure string match
          const actions = permissionsMap[modIdStr];
          console.log("actions", actions);
          if (!actions) return mod; // untouched module
          return {
            ...mod,
            actions: {
              add: actions.add,
              view: actions.view,
              edit: actions.edit,
              cancel: actions.cancel,
              approve: actions.approve,
              reject: actions.reject,
            },
            allowedToEdit: mod.allowedToEdit,
          };
        });
        return {
          ...entry,
          modules: updatedModules,
        };
      }
    });
    setData((prev: any) => ({
      ...prev,
      accessibility: updatedAccessibility,
    }));
    console.log("22222::data", data_);
    console.log("departmentData", departmentData);

    if (
      Array.isArray(data_?.siteAccessibility) &&
      typeof data_.siteAccessibility[0] === "object" &&
      data_.siteAccessibility[0] !== null &&
      "siteID" in data_.siteAccessibility[0] // or use 'siteId' if that's the actual key
    ) {
      data_.siteAccessibility = data_.siteAccessibility.map(
        (item: any) => item.siteID ?? item.siteId
      );
    }
    // if (
    //   departmentData.find((obj: any) => obj.value == originalData.department)
    // ) {
    //   data_.department = departmentData.find(
    //     (obj: any) => obj.value == originalData.department
    //   )?.value;
    //   data_.department = parseInt(data_.department);
    // } else {
    //   data_.department = parseInt(originalData.department);
    // }
    // console.log("reportingManagerRole", reportingManagerDropDownData);
    // if (
    //   reportingManagerDropDownData.find(
    //     (obj: any) => obj.value == originalData.reportingManagerRole
    //   )
    // ) {
    //   data_.reportingManagerRole = reportingManagerDropDownData.find(
    //     (obj: any) => obj.value == originalData.reportingManagerRole
    //   )?.value;
    //   data_.reportingManagerRole = parseInt(data_.reportingManagerRole);
    // } else {
    //   data_.reportingManagerRole = parseInt(originalData.reportingManagerRole);
    // }
    const formdat = formatAccessibilityData(updatedAccessibility);
    data_.accessibility = formdat;
    console.log("111", data_);
    data_.DOB = data_.DOB && dayjs(data_.DOB).format("YYYY-MM-DD");
    data_.DOJ = data_.DOJ && dayjs(data_.DOJ).format("YYYY-MM-DD");
    console.log("userSybmitDat", data_);
    // return;
    const finalData = {
      DOB: data_.DOB,
      DOJ: data_.DOJ,
      PIN: data_.PIN,
      accessibility: data_.accessibility,
      area: data_.area,
      bloodGroup: data_.bloodGroup,
      contractorAccessibility: data_.contractorAccessibility,
      country: data_.country,
      department: data_.departmentId,
      district: data_.district,
      email: data_.email,
      isContractorUser: data_.isContractorUser,
      name: data_.name,
      phoneNumber: data_.phoneNumber,
      referenceID: data_.referenceID,
      reportingManager: data_.reportingManager,
      reportingManagerRole: data_.reportingManagerRoleID,
      role: data_.role,
      siteAccessibility: data_.siteAccessibility,
      state: data_.state,
      prefferedStates: data_.prefferedStates || [],
    };
    try {
      const { status, message } = await usersApis.updateBuyerById(
        userId,
        finalData
      );
      if (status) {
        Swal.fire("Updated!", "User has been updated", "success");
        getViewDetails(userId);
      } else {
        Swal.fire("Failed!", message, "error");
      }
    } catch (error) {
      console.log("error", error);
      setAlertInfo({
        type: "error",
        message: "An unexpected error occurred",
        errors: [],
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  const formatAccessibilityData = (accessibility: any) => {
    const formattedModules = accessibility?.flatMap((entry: any) => {
      // Case 1: "Reports" - nested categories inside modules
      if (entry.category === "Reports") {
        return entry.modules.flatMap((subCat: any) =>
          subCat.modules.map((mod: any) => ({
            module: String(mod.moduleID),
            add: !!mod.actions?.add,
            view: !!mod.actions?.view,
            edit: !!mod.actions?.edit,
            cancel: !!mod.actions?.cancel,
            approve: !!mod.actions?.approve,
            reject: !!mod.actions?.reject,
          }))
        );
      }

      // Case 2: Normal categories
      return entry.modules.map((mod: any) => ({
        module: String(mod.moduleID),
        add: !!mod.actions?.add,
        view: !!mod.actions?.view,
        edit: !!mod.actions?.edit,
        cancel: !!mod.actions?.cancel,
        approve: !!mod.actions?.approve,
        reject: !!mod.actions?.reject,
      }));
    });
    return formattedModules;
  };

  const fetchModuleConfig = async () => {
    try {
      const res = await usersApis.getModuleConfig();
      const data = res.data;
      setaccessebilityKeys(data);
    } catch (err) {
      throw err;
    }
  };
  const fetchRoles = async () => {
    try {
      const { data, status, message } = await usersApis.fetchRolesData();
      if (status) {
        setRoleData(
          data.map((obj: any) => ({
            label: obj.roleName,
            value: obj.roleID.toString(),
          }))
        );
        setAllRolesData(data);
      } else {
        Swal.fire("Error", message, "error");
      }
    } catch (err: any) {
      Swal.fire("Error", err.response?.data?.message || err.message, "error");
    }
  };

  const fetchDept = async () => {
    try {
      const { data, status, message } = await usersApis.getDeptData();
      if (status) {
        setDepartmentData(
          data.map((obj: any) => ({
            label: obj.deptName,
            value: obj.deptID.toString(),
          }))
        );
      } else {
        Swal.fire("Error", message, "error");
      }
    } catch (err: any) {
      Swal.fire("Error", err.message, "error");
    }
  };

  // function to change the design view under 990 px
  const viewChange = () => {
    if (window.innerWidth < 990) {
      setMobileView(true);
    } else {
      setMobileView(false);
      updateSm(false);
    }
  };

  const fetchfetchReportingHierarchy = async (role: any) => {
    const { data, status, message } = await rolesApi.fetchReportingHierarchy();
    if (status && data) {
      let Data = data.find(
        (obj: any) => obj?.reportingRoleID == role && obj?.leader == false
      )?.reportingToRoleID;
      console.log("Data:::JJJJJJ", Data);
      fetchUsersByRoleId(Data);
    }
  };

  const getViewDetails = async (id: any) => {
    // try {
    const { data, status, message } = await usersApis.fetchBuyerById(id);
    console.log("status", data);
    if (status) {
      console.log("status", data);
      const newData = data;
      setData(newData); // Update data with fetched response
      setOriginalData(newData);
      setFormData({
        name: newData.name,
        referenceID: newData.referenceID,
        prefferedStates: newData.prefferedStates,
        email: newData.email,
        phoneNumber: newData.phoneNumber,
        PIN: newData.PIN,
        //   DOB: newData.DOB,
        //   DOJ: newData.DOJ,
        bloodGroup: newData.bloodGroup,
        area: newData.area,
        district: newData.district,
        state: newData.state,
        country: newData.country,
        userOrganisation: newData.userOrganisation,
        department: newData.department,
        role: newData.role,
        reportingManagerRole: newData.reportingManagerRole,
        reportingManager: newData.reportingManager,
        accessibility: [],
      });
      // console.log("accessibility", newData.accessibility);
      data?.accessibility?.forEach((moduleObj: any) => {
        console.log("accessibility", moduleObj);
        let moduleName = moduleObj?.module?.toString();
        setValue(`${moduleName}_add`, moduleObj.add);
        setValue(`${moduleName}_view`, moduleObj.view);
        setValue(`${moduleName}_edit`, moduleObj.edit);
        setValue(`${moduleName}_cancel`, moduleObj.cancel);
        setValue(`${moduleName}_approve`, moduleObj.approve);
        setValue(`${moduleName}_reject`, moduleObj.reject);
      });

      setValue("DOB", dayjs(data.DOB));
      setValue("DOJ", dayjs(data.DOJ));
      setValue("name", data.name);
      setValue("referenceID", data.referenceID);
      setValue(
        "prefferedStates",
        data.prefferedStates?.map((item: any) => item.stateID)
      );
      setValue("email", data.email);
      setValue("phoneNumber", data.phoneNumber);
      setValue("bloodGroup", data.bloodGroup);
      setValue("area", data.area);
      setValue("district", data.district.districtId);
      setValue("PIN", data.PIN);
      setValue("state", data.state.stateId);
      setValue("country", data.country.countryId);
      setValue("userOrganisation", data.userOrganisation);
      setValue("department", data.departmentName);
      setValue("role", data.role);
      setValue("reportingManagerRole", data.reportingManagerRoleName);
      setValue("reportingManager", data.reportingManager);
      console.log("data.reportingManager;0000", data.reportingManager);
      setGIModal(false);
      if (data.reportingManagerRole || data.reportingManager) {
        setShowreporting(true);
      }
      if (data?.reportingManager) {
        fetchfetchReportingHierarchy(data.role);
      }
      fetchStatesByCountry(newData.country.countryId, newData.state.stateId);
      getDistricts(newData.state.stateId, newData.district.districtId);
    } else {
      Swal.fire("Error", message, "error");
    }
  };

  useEffect(() => {
    fetchRoles();
    fetchDept();
    // fetchOrgs();
    fetchWorkingSites();
    viewChange();
    getCountries();
    fetchModuleConfig();
    window.addEventListener("load", viewChange);
    window.addEventListener("resize", viewChange);
    document
      .getElementsByClassName("nk-header")[0]
      .addEventListener("click", function () {
        updateSm(false);
      });
    const id = userId;
    console.log("id", id);
    if (id !== undefined || null || "") {
      getViewDetails(id);
    }
    return () => {
      window.removeEventListener("resize", viewChange);
      window.removeEventListener("load", viewChange);
    };
  }, [userId]);

  const openEditModal = (modalEditBlockName: any) => {
    setGIModal(true);
    setModalEditBlockName(modalEditBlockName);
  };

  const fetchUsersByRoleId = async (id: any) => {
    const {
      data: data_,
      status,
      message,
    } = await usersApis.fetchUsersByRoleId(id);
    if (status && data_) {
      setReportingMessage(false);
      if (alertInfo) {
        setAlertInfo({
          type: "",
          message: "",
          errors: [],
        });
      }
      let options = data_.map((obj: any) => ({
        label: obj.name,
        value: obj.userID,
      }));
      console.log("options", options);
      setReportingManagerDropDownData(options);
      // if (data?.reportingManager) {
      //   setValue(
      //     "reportingManager",
      //     data_.map((obj: any) => obj.reportingManager)
      //   );
      // }
      //  else {
      // setValue(
      //   "reportingManager",
      //   data_.find((obj: any) => obj?.userID === data?.reportingManager)?.userName
      // );
      // }
    } else {
      setReportingMessage(false);
      setValue("reportingManager", null);
      setReportingManagerDropDownData([]);
      setAlertInfo({
        type: "error",
        message: message,
        errors: [],
      });
    }
  };

  const fetchReportingManagerRole = async (selectRole: any) => {
    console.log("allRolesData", allRolesData);
    let role: any = allRolesData.find((obj: any) => obj.roleID == selectRole);
    setValue("department", role?.deptName);
    setValue("departmentId", role.deptID);
    // console.log("selectRole", selectRole);
    try {
      const { data, status, message } =
        await rolesApi.fetchReportingHierarchy();
      if (status) {
        console.log("data000111", data);
        // let findData = data.find((obj: any) => obj.reportingRoleID == selectRole && obj.leader == true);
        // console.log("findData",findData),
        // console.lo
        if (
          data.find(
            (obj: any) =>
              obj.reportingRoleID == selectRole && obj.leader == true
          )
        ) {
          setShowreporting(false);
          setValue("reportingManagerRole", null);
          setValue("reportingManagerRoleID", null);
          setReportingManagerDropDownData([]);
          setValue("reportingManager", null);
        } else if (
          data.find(
            (obj: any) =>
              obj.reportingRoleID == selectRole && obj.leader == false
          )
        ) {
          let Data = data.find(
            (obj: any) =>
              obj.reportingRoleID == selectRole && obj.leader == false
          ).reportingToRoleID;
          console.log("Data6666", Data, allRolesData);
          setShowreporting(true);
          if (allRolesData.find((obj: any) => obj.roleID == Data)) {
            console.log("75");
            let value = allRolesData.find(
              (obj: any) => obj.roleID == Data
            )?.roleName;
            console.log("value", value);
            setShowreporting(true);
            setValue(
              "reportingManagerRoleID",
              allRolesData.find((obj: any) => obj.roleID == Data)?.roleID
            );
            setValue("reportingManagerRole", value);
            fetchUsersByRoleId(Data);
          }
        } else {
          setShowreporting(false);
          setReportingMessage(true);
          setValue("reportingManagerRole", null);
          setReportingManagerDropDownData([]);
          setValue("reportingManagerRoleID", null);
          setValue("reportingManager", null);
        }
      } else {
        Swal.fire("Error", message, "error");
      }
    } catch (err: any) {
      Swal.fire("Error", err.response?.data?.message || err.message, "error");
    }
  };

  return (
    <React.Fragment>
      <Head title="Site Details - Regular"></Head>
      <Content>
        {data && (
          <>
            <BlockHead size="sm">
              <BlockBetween className="g-3">
                <BlockHeadContent>
                  <BlockTitle page>
                    User Details -{" "}
                    <strong className="text-primary small">
                      {data["name"]}
                    </strong>
                  </BlockTitle>
                  <BlockDes className="text-soft">
                    <ul className="list-inline">
                      <li>
                        Created At:{" "}
                        <span className="text-base">
                          {FormatDate(data.createdDate)}
                        </span>
                      </li>
                    </ul>
                  </BlockDes>
                </BlockHeadContent>
                <BlockHeadContent>
                  <Link to={`${process.env.PUBLIC_URL}/users`}>
                    <Button
                      outline
                      className="bg-white d-none d-sm-inline-flex"
                    >
                      <Icon name="arrow-left"></Icon>
                      <span>Back</span>
                    </Button>
                    <Button
                      outline
                      className="btn-icon bg-white d-inline-flex d-sm-none"
                    >
                      <Icon name="arrow-left"></Icon>
                    </Button>
                  </Link>
                </BlockHeadContent>
              </BlockBetween>
            </BlockHead>

            <Block>
              <Row className="gy-5">
                <Col
                  lg="5"
                  sm={undefined}
                  md={undefined}
                  xxl={undefined}
                  size={undefined}
                  className={undefined}
                >
                  <BlockHead>
                    <BlockBetween>
                      <BlockHeadContent>
                        <BlockTitle tag="h5">Personal Information</BlockTitle>
                        <p>Basic info, like your name and address...</p>
                      </BlockHeadContent>
                      <BlockHeadContent>
                        {allowedActions?.edit ? (
                          <Button
                            outline
                            className="d-none d-sm-inline-flex"
                            style={{ marginRight: "10px" }}
                            onClick={() => openEditModal("PersonalInformation")}
                          >
                            <Icon name="edit-alt-fill"></Icon>
                          </Button>
                        ) : (
                          <></>
                        )}
                      </BlockHeadContent>
                    </BlockBetween>
                  </BlockHead>
                  <Card className="card-bordered">
                    <ul className="data-list is-compact">
                      <li className="data-item">
                        <div className="data-col">
                          <div className="data-label">User ID</div>
                          <div className="data-value">{data.referenceID}</div>
                        </div>
                      </li>
                      <li className="data-item">
                        <div className="data-col">
                          <div className="data-label">User Name</div>
                          <div className="data-value">{data.name}</div>
                        </div>
                      </li>
                      <li className="data-item">
                        <div className="data-col">
                          <div className="data-label">Sales Territory</div>
                          <div className="data-value">
                            {data?.prefferedStates
                              ?.map(
                                (prefferedStates: any) =>
                                  prefferedStates.stateName
                              )
                              .join(", ")}
                          </div>
                        </div>
                      </li>
                      <li className="data-item">
                        <div className="data-col">
                          <div className="data-label">Email Address</div>
                          <div className="data-value">{data.email}</div>
                        </div>
                      </li>
                      <li className="data-item">
                        <div className="data-col">
                          <div className="data-label">Phone Number</div>
                          <div className="data-value">{data.phoneNumber}</div>
                        </div>
                      </li>
                      <li className="data-item">
                        <div className="data-col">
                          <div className="data-label">country</div>
                          <div className="data-value">
                            {data.country.countryName}
                          </div>
                        </div>
                      </li>
                      <li className="data-item">
                        <div className="data-col">
                          <div className="data-label">State</div>
                          <div className="data-value">
                            {data.state.stateName}
                          </div>
                        </div>
                      </li>
                      <li className="data-item">
                        <div className="data-col">
                          <div className="data-label">District</div>
                          <div className="data-value">
                            {data.district.districtName}
                          </div>
                        </div>
                      </li>
                      <li className="data-item">
                        <div className="data-col">
                          <div className="data-label">Area</div>
                          <div className="data-value">{data.area}</div>
                        </div>
                      </li>
                      <li className="data-item">
                        <div className="data-col">
                          <div className="data-label">Pin Code</div>
                          <div className="data-value">{data.PIN}</div>
                        </div>
                      </li>
                      <li className="data-item">
                        <div className="data-col">
                          <div className="data-label">Date of Birth</div>
                          <div className="data-value">
                            {FormatDate(data.DOB)}
                          </div>
                        </div>
                      </li>
                      <li className="data-item">
                        <div className="data-col">
                          <div className="data-label">Date of Joining</div>
                          <div className="data-value">
                            {FormatDate(data.DOJ)}
                          </div>
                        </div>
                      </li>
                      <li className="data-item">
                        <div className="data-col">
                          <div className="data-label">Blood Group</div>
                          <div className="data-value">{data.bloodGroup}</div>
                        </div>
                      </li>
                    </ul>
                  </Card>

                  <BlockHead>
                    <BlockBetween>
                      <BlockHeadContent>
                        <BlockTitle tag="h5">Hierarchy Setup </BlockTitle>
                        <p>Here is the current status of hierarchy setup.</p>
                      </BlockHeadContent>
                      <BlockHeadContent>
                        {allowedActions?.edit ? (
                          <Button
                            outline
                            className="d-none d-sm-inline-flex"
                            style={{ marginRight: "10px" }}
                            onClick={() => openEditModal("HeirarchySetup")}
                          >
                            <Icon name="edit-alt-fill"></Icon>
                          </Button>
                        ) : (
                          <></>
                        )}
                      </BlockHeadContent>
                    </BlockBetween>
                  </BlockHead>
                  <Card className="card-bordered">
                    <ul className="data-list is-compact">
                      <li className="data-item">
                        <div className="data-col">
                          <div className="data-label">Department</div>
                          <div className="data-value">
                            {
                              departmentData.find(
                                (item) => item.value == data.department
                              )?.label
                            }
                          </div>
                        </div>
                      </li>
                      <li className="data-item">
                        <div className="data-col">
                          <div className="data-label">Role</div>
                          <div className="data-value">
                            {
                              roleData.find((item) => item.value == data.role)
                                ?.label
                            }
                          </div>
                        </div>
                      </li>
                      <li className="data-item">
                        <div className="data-col">
                          <div className="data-label">
                            Reporting Manager Role
                          </div>
                          <div className="data-value">
                            {data.reportingManagerRoleName}
                          </div>
                        </div>
                      </li>
                      <li className="data-item">
                        <div className="data-col">
                          <div className="data-label">Reporting Manager</div>
                          <div className="data-value">
                            {data.reportingManagerName}
                          </div>
                        </div>
                      </li>
                    </ul>
                  </Card>
                </Col>

                {data?.accessibility?.map((item: any) => {
                  if (item.category !== "Reports") {
                    return (
                      <Col
                        lg="7"
                        sm={undefined}
                        md={undefined}
                        xxl={undefined}
                        size={undefined}
                        className={undefined}
                      >
                        <BlockHead>
                          <BlockBetween>
                            <BlockHeadContent>
                              <BlockTitle tag="h5">{item.category} </BlockTitle>
                              <p>{item.category} Accessibility Details etc.</p>
                            </BlockHeadContent>
                            <BlockHeadContent>
                              {allowedActions?.edit ? (
                                <Button
                                  outline
                                  className="d-none d-sm-inline-flex"
                                  style={{ marginRight: "10px" }}
                                  onClick={() => openEditModal(item.category)}
                                >
                                  <Icon name="edit-alt-fill"></Icon>
                                </Button>
                              ) : (
                                <></>
                              )}
                            </BlockHeadContent>
                          </BlockBetween>
                        </BlockHead>

                        <Card className="card-bordered">
                          <table
                            className="table table-hover"
                            id="accessesbility"
                          >
                            <thead>
                              <tr>
                                {updatedAccessibilityOptions.map(
                                  (_item: any) => {
                                    return (
                                      <th key={_item.value}>{_item.label}</th>
                                    );
                                  }
                                )}
                              </tr>
                            </thead>
                            <tbody>
                              {item.modules?.map((item_: any) => {
                                return (
                                  <tr>
                                    <td>{item_?.moduleName}</td>
                                    <td>
                                      {item_?.actions?.add == 1 ? (
                                        <Icon
                                          name="check-circle-fill"
                                          className="text-success"
                                        />
                                      ) : (
                                        <Icon
                                          name="cross-circle-fill"
                                          className="text-danger"
                                        />
                                      )}
                                    </td>
                                    <td>
                                      {item_?.actions?.view ? (
                                        <Icon
                                          name="check-circle-fill"
                                          className="text-success"
                                        />
                                      ) : (
                                        <Icon
                                          name="cross-circle-fill"
                                          className="text-danger"
                                        />
                                      )}
                                    </td>
                                    <td>
                                      {item_?.actions?.edit ? (
                                        <Icon
                                          name="check-circle-fill"
                                          className="text-success"
                                        />
                                      ) : (
                                        <Icon
                                          name="cross-circle-fill"
                                          className="text-danger"
                                        />
                                      )}
                                    </td>
                                    <td>
                                      {item_?.actions?.cancel ? (
                                        <Icon
                                          name="check-circle-fill"
                                          className="text-success"
                                        />
                                      ) : (
                                        <Icon
                                          name="cross-circle-fill"
                                          className="text-danger"
                                        />
                                      )}
                                    </td>
                                    <td>
                                      {item_?.actions?.approve ? (
                                        <Icon
                                          name="check-circle-fill"
                                          className="text-success"
                                        />
                                      ) : (
                                        <Icon
                                          name="cross-circle-fill"
                                          className="text-danger"
                                        />
                                      )}
                                    </td>
                                    {/* <td>
                                               {item_?.actions?.reject ? (
                                                 <Icon
                                                   name="check-circle-fill"
                                                   className="text-success"
                                                 />
                                               ) : (
                                                 <Icon
                                                   name="cross-circle-fill"
                                                   className="text-danger"
                                                 />
                                               )}
                                             </td> */}
                                  </tr>
                                );
                              })}
                            </tbody>
                          </table>
                        </Card>
                      </Col>
                    );
                  } else if (item.category === "Reports") {
                    return (
                      <Col
                        lg="7"
                        sm={undefined}
                        md={undefined}
                        xxl={undefined}
                        size={undefined}
                        className={undefined}
                      >
                        <BlockHead>
                          <BlockBetween>
                            <BlockHeadContent>
                              <BlockTitle tag="h5">{item.category} </BlockTitle>
                              <p>{item.category} Accessibility Details etc.</p>
                            </BlockHeadContent>
                            <BlockHeadContent>
                              {allowedActions?.edit ? (
                                <Button
                                  outline
                                  className="d-none d-sm-inline-flex"
                                  style={{ marginRight: "10px" }}
                                  onClick={() => openEditModal(item.category)}
                                >
                                  <Icon name="edit-alt-fill"></Icon>
                                </Button>
                              ) : (
                                <></>
                              )}
                            </BlockHeadContent>
                          </BlockBetween>
                        </BlockHead>

                        <Card className="card-bordered">
                          {item.modules?.map((item__: any) => (
                            <>
                              <div
                                key={item__.category}
                                style={{ margin: "2%" }}
                              >
                                <h5>{item__.category}</h5>
                              </div>
                              <table
                                className="table table-hover"
                                id="accessesbility"
                              >
                                <thead>
                                  <tr>
                                    <th className="w-70">Sub-Feature</th>
                                    {updatedReportsAccessibilityOptions.map(
                                      (opt: any) => {
                                        return (
                                          <th key={opt.value}>{opt.label}</th>
                                        );
                                      }
                                    )}
                                  </tr>
                                </thead>
                                <tbody>
                                  {item__.modules?.map((item_: any) => {
                                    return (
                                      <tr>
                                        <td className="w-70">
                                          {item_?.moduleName}
                                        </td>

                                        <td className="">
                                          {item_?.actions?.view ? (
                                            <Icon
                                              name="check-circle-fill"
                                              className="text-success"
                                            />
                                          ) : (
                                            <Icon
                                              name="cross-circle-fill"
                                              className="text-danger"
                                            />
                                          )}
                                        </td>
                                      </tr>
                                    );
                                  })}
                                </tbody>
                              </table>
                            </>
                          ))}
                        </Card>
                      </Col>
                    );
                  }
                })}
              </Row>
            </Block>

            <Modal
              isOpen={modalGI}
              className="modal-dialog-centered"
              size="xl"
              toggle={() => setGIModal(false)}
              backdrop="static"
            >
              <a
                href="#dropdownitem"
                onClick={(ev) => {
                  ev.preventDefault();
                  setGIModal(false);
                }}
                className="close"
              >
                <Icon name="cross-sm"></Icon>
              </a>
              {modalEditBlockName === "PersonalInformation" && (
                <ModalBody>
                  <div className="">
                    <div className="nk-modal-head">
                      <h5 className="title">Edit Personal Information </h5>
                    </div>
                    <div className="nk-tnx-details mt-sm-3">
                      <FormProvider {...methods}>
                        <form onSubmit={handleSubmit(onSubmit)}>
                          <Row className="gy-4">
                            <Col md="6">
                              <FormInput
                                name="referenceID"
                                label="User ID"
                                required={true}
                                disabled
                                type="text"
                                maxLength={10}
                                placeholder="Enter User ID"
                              />
                            </Col>
                            <Col md="6">
                              <FormInput
                                name="name"
                                label="User Name"
                                required={true}
                                type="text"
                                maxLength={50}
                                placeholder="Enter User Name"
                              />
                            </Col>

                            <Col md="6">
                              <FormMultiSelect
                                label="Sales Territory"
                                name="prefferedStates"
                                options={states}
                                placeholder="Select Sales Territory"
                              />
                            </Col>
                            <Col md="6">
                              <FormInput
                                name="email"
                                label="Email Address"
                                type="email"
                                required={true}
                                maxLength={50}
                                placeholder="Enter Email Address"
                              />
                            </Col>
                            <Col md="6">
                              <FormInput
                                name="phoneNumber"
                                label="Phone Number"
                                type="text"
                                pattern={/^\d+$/} // Allows only digits
                                onInput={(e: any) => {
                                  e.target.value = e.target.value.replace(
                                    /[^0-9]/g,
                                    ""
                                  ); // Removes non-numeric characters
                                }}
                                required={true}
                                placeholder="Enter Phone Number"
                              />
                            </Col>
                            <Col md="6">
                              <FormSelect
                                name="country"
                                label="Country"
                                options={countries}
                                required={true}
                                placeholder="Enter Country"
                                defaultValue={countries.find(
                                  (option: any) =>
                                    option.value == formData.country.countryId
                                )}
                              />
                            </Col>
                            <Col md="6">
                              <FormSelect
                                name="state"
                                label="State"
                                options={states}
                                placeholder="Select State"
                                required={true}
                                defaultValue={states.find(
                                  (option: any) =>
                                    option.value == formData.state.stateId
                                )}
                                onChange={(ev) => onStateChange(ev)}
                              />
                            </Col>
                            <Col md="6">
                              <FormSelect
                                name="district"
                                label="District"
                                options={districtOptions}
                                defaultValue={districtOptions.find(
                                  (option: any) =>
                                    option.value == formData.district.districtId
                                )}
                                required={true}
                                placeholder="Enter District"
                              />
                            </Col>
                            <Col md="6">
                              <FormInput
                                name="area"
                                label="Area"
                                placeholder="Enter Area"
                                required={true}
                              />
                            </Col>
                            <Col md="6">
                              <FormInput
                                name="PIN"
                                label="PIN"
                                required={true}
                                type="number"
                                maxLength={6}
                                placeholder="Enter PIN"
                              />
                            </Col>
                            <Col md="6">
                              <div className="form-group">
                                <FormDatePicker
                                  name="DOB"
                                  label="Date of Birth"
                                  maxDate={new Date()}
                                />
                              </div>
                            </Col>
                            <Col md="6">
                              <div className="form-group">
                                <FormDatePicker
                                  name="DOJ"
                                  label="Date of Joining"
                                />
                              </div>
                            </Col>
                            <Col md="6">
                              <FormInput
                                name="bloodGroup"
                                label="Blood Group"
                                type="text"
                                placeholder="Enter Blood Group"
                              />
                            </Col>
                          </Row>
                          <Row className="gy-4 mt-2">
                            <Col md="12">
                              <ul className="align-center flex-wrap flex-sm-nowrap gx-4 gy-2">
                                <li>
                                  {isSubmitting ? (
                                    <Button color="primary" type="button">
                                      <Spinner size="sm" color="light" />
                                    </Button>
                                  ) : (
                                  <Button
                                    color="primary"
                                    size="lg"
                                    type="submit"
                                  // onClick={() => submitForm()}
                                  >
                                    Update
                                  </Button>
                                  )}
                                </li>
                                <li>
                                  <a
                                    href="#dropdownitem"
                                    onClick={(ev) => {
                                      ev.preventDefault();
                                      setGIModal(false);
                                    }}
                                    className="link link-light"
                                  >
                                    Cancel
                                  </a>
                                </li>
                              </ul>
                            </Col>
                          </Row>
                        </form>
                      </FormProvider>
                    </div>
                  </div>
                </ModalBody>
              )}
              {modalEditBlockName === "HeirarchySetup" && (
                <ModalBody>
                  <div className="">
                    <div className="nk-modal-head">
                      <h5 className="title">Edit Hierarchy Setup </h5>
                    </div>
                    {alertInfo.message && (
                      <div className="mb-3 mt-1">
                        <Alert
                          color={
                            alertInfo.type === "error" ? "danger" : "success"
                          }
                          className="alert-icon"
                        >
                          <strong>{alertInfo.message}</strong>
                          <Icon
                            name={
                              alertInfo.type === "error"
                                ? "alert-circle"
                                : "check-circle"
                            }
                          />
                          {alertInfo.errors.length > 0 ? (
                            <ul>
                              {alertInfo.errors.map((err: any, index: any) => (
                                <li key={index}>{err}</li>
                              ))}
                            </ul>
                          ) : (
                            ""
                          )}
                        </Alert>
                      </div>
                    )}
                    {reportingMessage && (
                      <div className="mb-3 mt-1">
                        <Alert color={"danger"} className="alert-icon">
                          {/* <strong>{alertInfo.message}</strong> */}
                          <Icon name={"alert-circle"} />
                          <strong>
                            {" "}
                            Organisation Structure Is Not Defined For This{" "}
                          </strong>
                        </Alert>
                      </div>
                    )}
                    <div className="nk-tnx-details mt-sm-3">
                      <FormProvider {...methods}>
                        <form onSubmit={methods.handleSubmit(onSubmit)}>
                          <Row className="gy-4">
                            <Col lg="4">
                              <FormSelect
                                name="role"
                                label="Role"
                                options={roleData}
                                required={true}
                                placeholder="Select Role"
                                onChange={(e) => {
                                  console.log("selectRole111", e);
                                  fetchReportingManagerRole(e);
                                }}
                              />
                            </Col>
                            <Col lg="4">
                              <FormInput
                                name="department"
                                label="Department"
                                // options={departmentData}
                                required={true}
                                placeholder="Select Department"
                                disabled={getValues("department") != null}
                              />
                            </Col>
                            {/* {showreporting && ( */}
                            {/* <> */}
                            {showreporting &&
                              getValues("reportingManagerRole") && (
                                <Col lg="4">
                                  <FormInput
                                    name="reportingManagerRole"
                                    label="Reporting Manager Role"
                                    // options={reportingManagerRoleDropDownData}
                                    required={true}
                                    disabled
                                    placeholder="Select"
                                  />
                                </Col>
                              )}
                            {((showreporting && getValues("reportingManager")) ||  (showreporting && reportingManagerDropDownData) )&& (
                              <Col lg="4">
                                <FormSelect
                                  name="reportingManager"
                                  label="Reporting Manager"
                                  options={reportingManagerDropDownData}
                                  required={true}
                                  placeholder="Select"
                                />
                              </Col>
                            )}
                          </Row>
                          <Row className="gy-4 mt-2">
                            <Col size="12">
                              <ul className="align-center flex-wrap flex-sm-nowrap gx-4 gy-2">
                                <li>
                                  <Button
                                    color="primary"
                                    size="lg"
                                    type="submit"
                                  // onClick={() => submitForm()}
                                  >
                                    Update
                                  </Button>
                                </li>
                                <li>
                                  <a
                                    href="#dropdownitem"
                                    onClick={(ev) => {
                                      ev.preventDefault();
                                      setGIModal(false);
                                    }}
                                    className="link link-light"
                                  >
                                    Cancel
                                  </a>
                                </li>
                              </ul>
                            </Col>
                          </Row>
                        </form>
                      </FormProvider>
                    </div>
                  </div>
                </ModalBody>
              )}
              {modalEditBlockName !== "PersonalInformation" &&
                modalEditBlockName !== "HeirarchySetup" && (
                  <>
                    {/* <ModalHeader>
                      {modalEditBlockName} Access Details
                    </ModalHeader>
                    <ModalBody>
                      <UserAccessibilityModal
                        selectedViewDetailsName={modalEditBlockName}
                        data={data}
                        onSave={(data: any) => {
                          setModalEditBlockName("");
                          console.log("111111data", data);
                          // methods.reset({ ...methods.getValues(), ...data }); // or use setValue for specific fields
                          onSubmit(data);
                          setGIModal(false);
                        }}
                        onCancel={() => {
                          setGIModal(false);
                        }}
                      />
                    </ModalBody> */}
                    <ModalBody>
                      <div className="">
                        <div className="nk-modal-head">
                          <h5 className="title">Edit Accessibility </h5>
                        </div>
                        <div className="nk-tnx-details mt-sm-3">
                          <FormProvider {...methods}>
                            <form onSubmit={methods.handleSubmit(onSubmit)}>
                              <Row className="gy-4">
                                <Col size="12">
                                  {modalEditBlockName === "Reports" ? (
                                    <>
                                      {/* Render one table per report sub-category */}
                                      {data.accessibility
                                        ?.find(
                                          (obj: any) =>
                                            obj.category === modalEditBlockName
                                        )
                                        ?.modules.map((reportCategory: any) => (
                                          <div
                                            key={reportCategory.category}
                                            style={{ marginBottom: 40 }}
                                          >
                                            <h5>{reportCategory.category}</h5>
                                            <table
                                              className="table table-hover"
                                              id="accessesbility"
                                            >
                                              <thead>
                                                <tr>
                                                  <th className="w-70">
                                                    Sub-Feature
                                                  </th>
                                                  {updatedReportsAccessibilityOptions.map(
                                                    (opt) => (
                                                      <th key={opt.value}>
                                                        {opt.label}
                                                      </th>
                                                    )
                                                  )}
                                                </tr>
                                              </thead>
                                              <tbody>
                                                {reportCategory.modules.map(
                                                  (item: any) => {
                                                    const actionTypes = [
                                                      // "add",
                                                      "view",
                                                      // "edit",
                                                      // "cancel",
                                                      // "approve",
                                                    ];
                                                    // Set default checkbox values on load
                                                    actionTypes.forEach(
                                                      (action) => {
                                                        const name = `${modalEditBlockName}_${item.moduleID}_${action}`;
                                                        const isChecked =
                                                          Number(
                                                            item.actions?.[
                                                            action
                                                            ]
                                                          ) === 1;
                                                        setValue(
                                                          name,
                                                          isChecked
                                                        );
                                                      }
                                                    );

                                                    return (
                                                      <tr key={item.moduleID}>
                                                        <td className="w-70">
                                                          {item.moduleName}
                                                        </td>
                                                        {actionTypes.map(
                                                          (action) => {
                                                            const name = `${modalEditBlockName}_${item.moduleID}_${action}`;
                                                            const isDisabled =
                                                              action !==
                                                              "view" &&
                                                              !item.allowedToEdit?.includes(
                                                                action
                                                              );
                                                            return (
                                                              <td key={name}>
                                                                <FormCheckbox
                                                                  name={name}
                                                                  optionLabel=""
                                                                  noGap={true}
                                                                  size="small"
                                                                  disabled={
                                                                    isDisabled
                                                                  }
                                                                />
                                                              </td>
                                                            );
                                                          }
                                                        )}
                                                      </tr>
                                                    );
                                                  }
                                                )}
                                              </tbody>
                                            </table>
                                          </div>
                                        ))}
                                    </>
                                  ) : modalEditBlockName === "Masters" ||
                                    modalEditBlockName === "Dashboard" ? (
                                    <table
                                      className="table table-hover"
                                      id="accessesbility"
                                    >
                                      <thead>
                                        <tr>
                                          <th>Sub-Feature</th>
                                          <th>Accessibility</th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        {(() => {
                                          const foundCategory =
                                            data.accessibility?.find(
                                              (obj: any) =>
                                                obj.category ===
                                                modalEditBlockName
                                            );
                                          console.log(
                                            "modalEditBlockName",
                                            modalEditBlockName
                                          );
                                          if (!foundCategory) return null;
                                          console.log(
                                            "foundCategory",
                                            foundCategory
                                          );
                                          return foundCategory.modules.map(
                                            (mod: any, i: number) => {
                                              const actionTypes = ["add"];
                                              actionTypes.forEach((action) => {
                                                const name = `${modalEditBlockName}_${mod.moduleID}_${action}`;
                                                console.log("name", name);
                                                const isChecked =
                                                  modalEditBlockName ===
                                                    "Masters"
                                                    ? Number(
                                                      mod.actions?.[action]
                                                    ) === 1
                                                    : Number(
                                                      mod.actions?.["view"]
                                                    ) === 1;
                                                console.log(
                                                  "isChecked",
                                                  isChecked
                                                );
                                                setValue(name, isChecked);
                                              });

                                              return (
                                                <tr key={mod.moduleID}>
                                                  <td>{mod.moduleName}</td>
                                                  {actionTypes.map((action) => {
                                                    const name = `${modalEditBlockName}_${mod.moduleID}_${action}`;
                                                    const isDisabled =
                                                      action !== "view" &&
                                                      !mod.allowedToEdit?.includes(
                                                        action
                                                      );
                                                    return (
                                                      <td key={name}>
                                                        <FormCheckbox
                                                          name={name}
                                                          optionLabel=""
                                                          noGap={true}
                                                          size="small"
                                                          disabled={isDisabled}
                                                        />
                                                      </td>
                                                    );
                                                  })}
                                                </tr>
                                              );
                                              //   }
                                              // );
                                            }
                                          );
                                        })()}
                                      </tbody>
                                    </table>
                                  ) : (
                                    <table
                                      className="table table-hover"
                                      id="accessesbility"
                                    >
                                      <thead>
                                        <tr>
                                          {updatedAccessibilityOptions.map(
                                            (_item: any) => {
                                              return (
                                                <th key={_item.value}>
                                                  {_item.label}
                                                </th>
                                              );
                                            }
                                          )}
                                        </tr>
                                      </thead>
                                      <tbody>
                                        {(() => {
                                          if (!modalEditBlockName) return null;
                                          const foundCategory =
                                            data.accessibility?.find(
                                              (obj: any) =>
                                                obj.category ===
                                                modalEditBlockName
                                            );
                                          if (!foundCategory) return null;
                                          return (
                                            <>
                                              {foundCategory?.modules?.map(
                                                (item: any, index: number) => {
                                                  if (!item || !item.moduleID)
                                                    return null;
                                                  setValue(
                                                    `${modalEditBlockName}_${item.moduleID}_add`,
                                                    Number(
                                                      item?.actions?.add
                                                    ) === 1
                                                  );
                                                  setValue(
                                                    `${modalEditBlockName}_${item.moduleID}_view`,
                                                    Number(
                                                      item?.actions?.view
                                                    ) === 1
                                                  );
                                                  setValue(
                                                    `${modalEditBlockName}_${item.moduleID}_edit`,
                                                    Number(
                                                      item?.actions?.edit
                                                    ) === 1
                                                  );
                                                  setValue(
                                                    `${modalEditBlockName}_${item.moduleID}_cancel`,
                                                    Number(
                                                      item?.actions?.cancel
                                                    ) === 1
                                                  );
                                                  setValue(
                                                    `${modalEditBlockName}_${item.moduleID}_approve`,
                                                    Number(
                                                      item?.actions?.approve
                                                    ) === 1
                                                  );
                                                  return (
                                                    <tr key={`item-${index}`}>
                                                      <td>{item.moduleName}</td>
                                                      <td>
                                                        <FormCheckbox
                                                          name={`${modalEditBlockName}_${item.moduleID}_add`}
                                                          disabled={
                                                            !item?.allowedToEdit?.includes(
                                                              "add"
                                                            )
                                                          }
                                                          optionLabel=""
                                                          noGap={true}
                                                          size={"small"}
                                                        />
                                                      </td>
                                                      <td>
                                                        <FormCheckbox
                                                          name={`${modalEditBlockName}_${item.moduleID}_view`}
                                                          optionLabel=""
                                                          noGap={true}
                                                          size={"small"}
                                                        />
                                                      </td>
                                                      <td>
                                                        <FormCheckbox
                                                          disabled={
                                                            !item?.allowedToEdit?.includes(
                                                              "edit"
                                                            )
                                                          }
                                                          name={`${modalEditBlockName}_${item.moduleID}_edit`}
                                                          optionLabel=""
                                                          noGap={true}
                                                          size={"small"}
                                                        />
                                                      </td>
                                                      <td>
                                                        <FormCheckbox
                                                          disabled={
                                                            !item?.allowedToEdit?.includes(
                                                              "cancel"
                                                            )
                                                          }
                                                          name={`${modalEditBlockName}_${item.moduleID}_cancel`}
                                                          optionLabel=""
                                                          noGap={true}
                                                          size={"small"}
                                                        />
                                                      </td>
                                                      <td>
                                                        <FormCheckbox
                                                          disabled={
                                                            !item?.allowedToEdit?.includes(
                                                              "approve"
                                                            )
                                                          }
                                                          name={`${modalEditBlockName}_${item.moduleID}_approve`}
                                                          optionLabel=""
                                                          noGap={true}
                                                          size={"small"}
                                                        />
                                                      </td>
                                                    </tr>
                                                  );
                                                }
                                              )}
                                            </>
                                          );
                                        })()}
                                      </tbody>
                                    </table>
                                  )}
                                </Col>
                              </Row>
                              <Row className={undefined}>
                                <Col size="12">
                                  <ul className="align-center flex-wrap flex-sm-nowrap gx-4 gy-2">
                                    <li>
                                      <Button
                                        color="primary"
                                        size="lg"
                                        type="submit"
                                      // onClick={() => submitForm()}
                                      >
                                        Update
                                      </Button>
                                    </li>
                                    <li>
                                      <a
                                        href="#dropdownitem"
                                        onClick={(ev) => {
                                          ev.preventDefault();
                                          setGIModal(false);
                                        }}
                                        className="link link-light"
                                      >
                                        Cancel
                                      </a>
                                    </li>
                                  </ul>
                                </Col>
                              </Row>
                            </form>
                          </FormProvider>
                        </div>
                      </div>
                    </ModalBody>
                  </>
                )}
            </Modal>
          </>
        )}
      </Content>
    </React.Fragment>
  );
};

export default UserViewDetails;
